import React from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { FCC } from '@zazume/zzm-base';

const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    line-height: ${theme.lineHeights.md};
    gap: ${theme.spacing.s4};
    align-items: center;
  `
);

export const Title: FCC<any> = ({ children }) => {
  return <Container>{children}</Container>;
};
